
    import { ValidationProvider } from "vee-validate";
    import Vue from 'vue';

    export default Vue.extend({
        name: "CheckboxControl",
        components: {
            ValidationProvider
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            rules: {
                type: [String, Object],
                default: ""
            },
            label: {
                type: String,
                default: ""
            },
            helpText: {
                type: String,
                default: ""
            },
            tooltipText: {
                type: String,
                default: ""
            },
            name: {
                type: String,
                default: ""
            },
            vid: {
                type: String,
                default: undefined
            },
        },
        data() {
            return {
                checkedProxy: false
            }
        },
        computed: {
            checked: {
                get(): boolean {
                    return this.value
                },
                set(val: boolean): void {
                    this.checkedProxy = val
                }
            }
        },
        methods: {
            handleChange() {
                this.$emit('input', this.checkedProxy)
            }
        }
    });
